/**
 * @file: useRefreshFeedback.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { SoundFile } from '@euler/assets';
import { useCallback } from 'react';
import { usePlaySoundEffect } from './usePlaySoundEffect';

export const useRefreshFeedback = () => {
  const playSoundEffect = usePlaySoundEffect(SoundFile.message01, 0.5);

  return useCallback(async () => {
    await playSoundEffect();
  }, [playSoundEffect]);
};
